import React,{useState, useEffect} from 'react'
import '../../CSS/HomePage.css'
import Button from "@material-tailwind/react/Button";
import { Link } from 'react-router-dom'
import { useStateValue } from '../../StateProvider';
import homePageImg from '../../img/homePageImg.png'
import WeHelpWith from './WeHelpWith';
import DiscoverPage from './DiscoverPage';
import HomeSelectModeS from './HomeSelectModeS';
import Footer from './Footer';
import HomePageNew from '../HomePageNew'
const HomePage = () => {

    const [userData, setUserData] = useState(localStorage.getItem('user'));
    const [{user}] = useStateValue();
    useEffect(() => {
        setUserData(JSON.parse(window.localStorage.getItem('user')));
    }, []);
    return (   
     <>
     <div className="homePage">       
           <div className="homeSubDiv1">
                { /* <div className="navDiv">
                    <NavTablet />
                </div> */}
                <div className="homeSubDivLeft">
                
                    <h1>Not Feeling Happy You Know Where To Come</h1>
                    <p>Your companion, guide, and Friend in the journey of life</p>
                        { userData ? (
                            <Link to='/AppointmentPage'> 
                                <Button color="lightBlue" size="lg" ripple="light" id='getStrBtn'>Get started</Button>
                            </Link>
                        ) : (
                            <div className="lgnButtonDiv">
                                <Link to={user ? '/take_test' : '/login_Signup'}> 
                                <Button color="lightBlue" size="lg" ripple="light" id='userButtons'>Login</Button>
                                <Button
                                    id='userButtons'
                                    color="lightBlue"
                                    buttonType="outline"
                                    size="regular"
                                    rounded={false}
                                    ripple="dark">
                                    SignUp
                                </Button>
                                </Link>
                            </div>
                        ) }
                </div>

                <div className="homeSubDivRight">
                    <img src={homePageImg} alt="Home" />
                </div> 
            </div>
            <WeHelpWith />
            <HomeSelectModeS />
            <DiscoverPage />
            <Footer />
        </div>  
    </>
    )
}

export default HomePage
